import Box from '@mui/material/Box';

import { Alert } from 'flyt';

import { flyt } from 'web/theme/theme';

const severities = ['error', 'warning', 'info', 'success'];

export default function Message({
	title = null,
	type,
	onClose = undefined,
	children,
}) {
	const status = severities.includes(type) ? type : 'info';

	return (
		<Box
			sx={{
				mb: 2,
				maxWidth: flyt.alertMaxWidth,
				textAlign: 'left',
			}}
		>
			<Alert status={status} title={title ?? undefined} onClose={onClose}>
				{children}
			</Alert>
		</Box>
	);
}
